module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAVpJREFUSA1jYMABZm8X3wrCOKQJChPSz4LLhP///3vhkiNGnJB+lvn7FQT+/Pg29z8DozfD///saV6vGLEZPGub2H9s4uhiePUzMv5kZPi/lYWDK5nlz4/vPf//MwQxMBBlLro9pPGBHgPaEgS08z0oqP1AuhlZmbVSXZ9fx2USLp/gUo8uDtI/e7ek5v/ff68B5fyYgHEhClKEbikjI+M2BkZGshMXNv0wO0B24kxcqZ4vvdFdTQqfkH4mUgyjplpGYlMrNS0FmTVgPobHMaWpltgQgYXwgPmYoMUgF8JcCfIVpXxYyBC0GKaQ2jQ8VY/cOKY0Dgnph0XZaBzDQoLmNEZQE4ojSuVhPsKwGCZBa3o0H1NcFqOnAVxRNhLjmJHhOSg45uyQoKhxhytIkcXhdgDtZJyzQ7zj37//5cgKaM1mYmLsZOKTFakDMRigPqeppUA7QHaB7AQAXjvnIVs/hsoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/utils/assets/images/calendar.png
// module id = 265
// module chunks = 0